import 'css-chunksrc/client/scenes/workloads/calendar/styles.scss';export default {
  "calendar": "_calendar_535me_1",
  "dates": "_dates_535me_10",
  "date": "_date_535me_10",
  "header": "_header_535me_28",
  "restDay": "_restDay_535me_36",
  "heading": "_heading_535me_40",
  "lastRestDay": "_lastRestDay_535me_44",
  "weeklyName": "_weeklyName_535me_63",
  "daily": "_daily_535me_67",
  "dayName": "_dayName_535me_77",
  "hours": "_hours_535me_82",
  "hour": "_hour_535me_82",
  "hourLabel": "_hourLabel_535me_97",
  "now": "_now_535me_106",
  "monthly": "_monthly_535me_120",
  "lastMonthDay": "_lastMonthDay_535me_127",
  "weekEndDay": "_weekEndDay_535me_130",
  "yearly": "_yearly_535me_134",
  "lastYearDay": "_lastYearDay_535me_144"
};